import React,{useState} from 'react'
import { Popup, Icon } from 'semantic-ui-react'
import isEmpty from 'lodash/isEmpty';
import get from 'lodash/get';
export default function CopyToClipboard(props) {
    const [copied, setCopied] = useState(false)
    if( isEmpty(get(props,'text','')) ){
        return ''
    }    
    return (
        <Popup            
			content={copied ? "Copied!" : "Click to copy"}
			position="top center"
			trigger={
					<Icon
                        style={{fontSize:"0.9em", ...get(props,'cssStyle',{})}}
					    name={copied ? "check circle" : "copy"}
						className="copyToClipboard"
						onClick={() => {
                            navigator.clipboard.writeText(get(props,'text',''));
                            setCopied( true );
                            setTimeout(() => {
                                setCopied( false );
                            }, 1500);                            
						}}
					/>
				}
			/>
    )
}
